import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  @Input() message: any;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit(): void {
    console.log(this.message)
  }

  dismiss(){
    this.modalController.dismiss();
  }

}
